import Cookies from "universal-cookie";
import axios from "axios";
import { teamAwareGet, teamAwarePost, teamAwarePut } from "../utils/teamApiHelper";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

// Create a new video conference
export function createVideoConference(data) {
    const url = process.env.REACT_APP_API_BASE_URL + "/conferences";
    return teamAwarePost(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Get all video conferences for a team
export function getVideoConferences() {
    const url = process.env.REACT_APP_API_BASE_URL + "/conferences";
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Get a specific video conference
export function getVideoConference(conferenceId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Update video conference
export function updateVideoConference(conferenceId, data) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}`;
    return axios.put(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Delete video conference
export function deleteVideoConference(conferenceId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}`;
    return axios.delete(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Join a video conference
export function joinVideoConference(conferenceId, data = {}) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/join`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Leave a video conference
export function leaveVideoConference(conferenceId, data = {}) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/leave`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Start recording
export function startRecording(conferenceId, options = {}) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/recording/start`;
    return axios.post(url, options, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Stop recording
export function stopRecording(conferenceId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/recording/stop`;
    return axios.post(url, {}, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Get recording status
export function getRecordingStatus(conferenceId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/recording/status`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Get conference recordings
export function getConferenceRecordings(conferenceId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/conferences/${conferenceId}/recordings`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Get recording download URL (with presigned URL for private files)
export function getRecordingDownloadUrl(recordingId) {
    const url = process.env.REACT_APP_API_BASE_URL + `/recordings/${recordingId}/download`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}